// Configure Stimulus
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "../controllers/register_controllers";

const application = Application.start();

const controllers = import.meta.glob("../src/storefront/controllers/**/*", { eager: true })
registerControllers(application, controllers)
